import { getSubscriptionInfo } from '@/services/api'
import { SERVICE_KEYS } from '@/constants'
import useSwr from 'swr'
import NP from 'number-precision'
import type { SubscribeRightTypes } from '@/services/api/subscribe/type'

/** 获取订阅信息 */
export function useGetSubscriptionInfo() {
  const { data: subscriptionInfo } = useSwr(['/api/crm/admin/subscription/info'], () => {
    return getSubscriptionInfo().then((res) => res.data)
  })

  const smsRight = subscriptionInfo?.rights
    ?.filter((item) => item.serviceKey === SERVICE_KEYS.ow_sms_meg)
    ?.reduce((prev, next) => {
      return {
        availableQty: NP.plus(prev.availableQty || 0, next.availableQty || 0),
      }
    }, {} as SubscribeRightTypes)

  return {
    subscriptionInfo,
    smsRight,
  }
}
